// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@charset \"UTF-8\";.preview-video[data-v-4ae7068a]{width:100vw;height:80vh}.preview-yyEva[data-v-4ae7068a]{width:46.1822660099vh; /* 动态计算宽度 */height:100vh;max-width:100vw;aspect-ratio:750/1624;margin:0 auto}.preview-yyEva.not[data-v-4ae7068a]{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
